module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_26-77fa9aeb019121521595b218e939fb4f.png";